module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/welcome-849ba687861acfcbc6fa1ac714381256.svg";